// extracted by mini-css-extract-plugin
export default {"product-id":"associatedGoods_product-id__zxcD0","relative":"associatedGoods_relative__6J8Nc","btn":"associatedGoods_btn__07H58"};